<template>
	<b-container v-if="isLoggedIn" fluid class="dashboard" v-animate-css="'fadeIn'">
		<div class="dashContent">
		<b-row class="dashRow firstDash">
			<b-col md="4">
				<div class="userProfile" v-if="userProfile.profileData">
					<img v-if="!userProfile.profileData.mbsdFile" src="/public/images/anonymous.jpg" class="avatar">
					<img v-if="userProfile.profileData.mbsdFile" :src="'https://facepool.oss-ap-southeast-5.aliyuncs.com/'+userProfile.profileData.mbsdFile" @error="photoProfileError" class="avatar">
					<h5 class="greetings">Sugeng Rawuh,</h5>
					<h4>{{userProfile.profileData.mbsdFullName}}</h4>
					<b-button to="/profile" pill variant="outline-secondary" size="sm">{{ $t("user.linktoprofile") }} <b-icon icon="arrow-right"></b-icon></b-button>
					<!-- <div class="regStatus">
						<label>Registration Status</label>
						<b-alert show variant="warning"><b-icon-stopwatch-fill></b-icon-stopwatch-fill> Waiting for Ballot Drawing</b-alert>
					</div> -->
				</div>
				<div class="funFacts">
					<label class="textLabel">{{ $t("user.trivia") }}</label>
					<div v-html="fact"></div>
				</div>
			</b-col>
			<b-col md="8">
				<div class="mainCard">
					<b-card
						img-src="/public/images/reg.jpg"
						img-alt="Registration"
						img-top
					>
					<div class="statusContainer">
						<div class="statusIdle" v-if="ballotStatus.readyToRegister">
							<h2>{{ $t("status.idle.head") }}</h2>
								<b-form @submit="onSubmit">
									<b-form-group id="" :label="$t('status.idle.label')" label-for="" :description="$t('status.idle.desc')">
										<b-form-select :options="regChannel" v-model="channel">
										<!-- <b-form-select-option value="regBallot">Ballot Casting</b-form-select-option> 
											<b-form-select-option value="regFrq">Fast Runner Qualifying</b-form-select-option>
											<b-form-select-option value="regBJ">Bank Jateng Program</b-form-select-option>
											<b-form-select-option value="regTravel">Travel Agent Partners</b-form-select-option>-->
										</b-form-select>
									</b-form-group>
									<b-button v-b-modal.registrationModal variant="primary" :disabled="channel==null">{{ $t("status.idle.btn") }}</b-button>
									<registration-modal :modal-data="channel"/>
								</b-form>
						</div>
						<div class="statusWait" v-if="ballotStatus.waiting">
							<h2>{{ $t("status.wait.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusWait"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.wait.label") }}</h6>
										<p>{{ $t("status.wait.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusFRQWait" v-if="ballotStatus.frqWaiting">
							<h2>{{ $t("status.FRQwait.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusWait"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.FRQwait.label") }}</h6>
										<p v-html="$t('status.FRQwait.desc')"></p>
									</b-col>
								</b-row>
						</div>
						<div class="statusSwitched" v-if="ballotStatus.fastRunnerRejected">
							<h2>{{ $t("status.switched.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusSwitched"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.switched.label") }}</h6>
										<p v-html="$t('status.switched.desc')"></p>
									</b-col>
								</b-row>
						</div>
						<div class="statusDrawing" v-if="ballotStatus.drawing">
							<h2>{{ $t("status.drawing.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusDrawing"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.drawing.label") }}</h6>
										<p>{{ $t("status.drawing.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusPay" v-if="ballotStatus.approved&&transactionData">
							<h2>{{ $t("status.pay.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusPay"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.pay.label") }}</h6>
										<i18n path="status.pay.desc" tag="p">
											<span place="timelimit"><strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong></span>
										</i18n>
									</b-col>
								</b-row>
							<b-button v-b-modal.jerseyModal variant="primary">{{ $t("status.pay.jbtn") }}</b-button>
							<jersey-modal/>

							<b-button v-b-modal.paymentModal variant="primary">{{ $t("status.pay.btn") }}</b-button>
							<payment-modal :transactionData="transactionData"/>
							
						</div>
						<div class="statusTransferring" v-if="ballotStatus.bibTransferInProgess">
							<h2>{{ $t("status.transferring.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusTransferring"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.transferring.label") }}</h6>
										<p>{{ $t("status.transferring.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusSuccess" v-if="ballotStatus.confirmed">
							<h2>{{ $t("status.success.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusSuccess"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.success.label") }}</h6>
										<p>{{ $t("status.success.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusBJsuccess" v-if="ballotStatus.confirmedViaBankJateng">
							<h2>{{ $t("status.BJsuccess.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<img src="https://assets.heartwork.co.id/bormar/bankjateng.svg" class="bankJateng">
									</b-col>
									<b-col>
										<h6>{{ $t("status.BJsuccess.label") }}</h6>
										<p>{{ $t("status.BJsuccess.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusUnlucky" v-if="ballotStatus.unlucky">
							<h2>{{ $t("status.unlucky.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusUnlucky"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.unlucky.label") }}</h6>
										<p>{{ $t("status.unlucky.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusUnpaid" v-if="ballotStatus.unpaid">
							<h2>{{ $t("status.unpaid.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusUnpaid"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.unpaid.label") }}</h6>
										<p>{{ $t("status.unpaid.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusTransferred" v-if="ballotStatus.transferred">
							<h2>{{ $t("status.transferred.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusTransferred"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.transferred.label") }}</h6>
										<p>{{ $t("status.transferred.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusClosed" v-if="ballotStatus.closed">
							<h2>{{ $t("status.closed.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusClosed"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.closed.label") }}</h6>
										<p v-html="$t('status.closed.desc')"></p>
									</b-col>
								</b-row>
						</div>
					</div>

					<div class="regData" v-if="ballotData&&ballotDataDetail">
						<!-- <pre>
							{{transferInfo}}
						</pre> -->
						<!-- <table>
								<tbody><tr>
									<td class="heady">Registration Code</td>
									<td>{{ballotData.mregOrderId}}</td>
								</tr><tr>
									<td class="heady">Registration Date</td>
									<td>{{ballotData.mregCreatedTime | moment("D MMMM YYYY - hh:mm")}} WIB (GMT+7)</td>
								</tr></tbody>
						</table> -->

						<b-row class="regCategory">
							<b-col md="auto">
								<div class="groupLabel"><label>{{ $t("regData.category.race") }}</label></div>
								<h1>{{ballotDataDetail.evrlEvpaCategory}}</h1>
							</b-col>
							<b-col>
								<div class="groupLabel"><label>{{ $t("regData.category.code") }}</label></div>
								<h5>{{ballotData.mregOrderId}}</h5>
								<p>{{ballotData.mregCreatedTime | moment("D MMMM YYYY - HH:mm")}} WIB (GMT+7)</p>
							</b-col>
						</b-row>

						<div class="groupLabel"><label>{{ $t("regData.details.head") }}</label></div>
						<table>
								<tbody><tr>
									<td class="heady">{{ $t("regData.details.corral") }}</td>
									<td>{{ballotDataDetail.evpaWave}}</td>
								</tr><tr>
									<td class="heady">{{ $t("regData.details.bib") }}</td>
									<td>{{ballotDataDetail.evpaBIBName}}</td>
								</tr><tr v-if="ballotDataDetail.evpaJersey!='-'">
									<td class="heady">{{ $t("regData.details.jersey") }}</td>
									<td>{{ballotDataDetail.evpaJersey}}</td>
								</tr><tr>
									<td class="heady">{{ $t("regData.details.community") }}</td>
									<td>{{ballotDataDetail.evpaCommunity}}</td>
								</tr>
								</tbody>
						</table>
						<div v-if="userProfile.fastRunnerInfo" class="FRQdata">
							<div class="groupLabel"><label>{{ $t("regData.frq.head") }}</label></div>
							<table>
									<tbody><tr>
										<td class="heady">{{ $t("regData.frq.qrace") }}</td>
										<td>{{userProfile.fastRunnerInfo.mmfrEventName}}</td>
									</tr><tr>
										<td class="heady">{{ $t("regData.frq.qcategory") }}</td>
										<td>{{userProfile.fastRunnerInfo.mmfrDescription}}</td>
									</tr><tr>
										<td class="heady">{{ $t("regData.frq.qtime") }}</td>
										<td>{{userProfile.fastRunnerInfo.mmfrResultTime}}</td>
									</tr></tbody>
							</table>
						</div>
						<div class="groupLabel"><label>{{ $t("regData.emergency.head") }}</label></div>
						<table>
								<tbody><tr>
									<td class="heady">{{ $t("regData.emergency.name") }}</td>
									<td>{{ballotDataDetail.evpaEmergencyContactName}}</td>
								</tr><tr>
									<td class="heady">{{ $t("regData.emergency.number") }}</td>
									<td>{{ballotDataDetail.evpaEmergencyContactNumber}}</td>
								</tr><tr>
									<td class="heady">{{ $t("regData.emergency.medic") }}</td>
									<td>{{ballotDataDetail.evpaMedicalTreatment}}</td>
								</tr></tbody>
						</table>
					</div>
						<!-- <b-form-group id="evpaBIBName-group" label="Name On BIB" label-for="evpaBIBName">
							<b-form-input
								id="evpaBIBName"
								v-model="form.evpaBIBName"
								:state="formStatus.evpaBIBName.state"
								required
								placeholder="Enter Your desired name on BIB"
							></b-form-input>
						</b-form-group>
						<b-form-group id="evpaEvncId-group" label="Category" label-for="evpaEvncId">
							<b-form-select
								id="evpaEvncId"
								v-model="form.evpaEvncId"
								:options="categories"
								required
							></b-form-select>
						</b-form-group>
						<b-form-group id="evpaWave-group" label="Target Finish Time" label-for="evpaWave">
							<vue-timepicker input-class="form-control" v-model="form.evpaWave" format="hh:mm"></vue-timepicker>
						</b-form-group>
						<b-button href="#" variant="primary">Join Now</b-button>-->
					</b-card>
				</div>
			</b-col>
		</b-row>
		<b-row class="dashRow">
			<b-col md="12">
				<b-card-group deck class="dashDisabled">
					<b-card
						:title="$t('friendship.card.head')"
						img-src="/public/images/fr.jpg"
						img-alt="Friendship Run"
						img-top
						class="dashCard"
					>
						<div class="friendshipCard">
							<b-card-text>
								{{ $t("friendship.card.desc") }}
							</b-card-text>
							<b-button v-b-modal.registrationModal block variant="primary" @click="channel='FRIENDSHIP'" disabled="disabled">{{ $t("friendship.card.btn") }}</b-button>
							<!-- <registration-modal/> -->
						</div>

						<div class="friendshipStatus" v-if="transactionStatus">
							<div class="statusPay">
								<b-row class="status">
									<b-col>
										<svg-image image="statusPay"/>
										<h6>{{ $t("friendship.status.pay.label") }}</h6>
										<p v-html="$t('friendship.status.pay.desc')"></p>
										<!-- <p>Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your Friendship Run registration.</p> -->
									</b-col>
								</b-row>
								<b-button v-b-modal.paymentModal block variant="primary">{{ $t("friendship.status.pay.btn") }}</b-button>
								<!-- <payment-modal :transactionData="transactionData"/> -->
							</div>
							<div class="statusUnpaid">
								<b-row class="status">
									<b-col>
										<svg-image image="statusUnpaid"/>
										<h6>{{ $t("friendship.status.unpaid.label") }}</h6>
										<p>{{ $t("friendship.status.unpaid.desc") }}</p>
									</b-col>
								</b-row>
								<b-button v-b-modal.busModal block variant="primary">{{ $t("friendship.status.unpaid.btn") }}</b-button>
							</div>
							<div class="statusSuccess">
								<b-row class="status">
									<b-col>
										<svg-image image="statusSuccess"/>
										<h6>{{ $t("friendship.status.success.label") }}</h6>
										<p>{{ $t("friendship.status.success.desc") }}</p>
									</b-col>
								</b-row>
							</div>
						</div>

						<div class="friendshipReg" v-if="transactionStatus">
							<table>
								<tbody>
								<tr><td class="heady">
									{{ $t("friendship.data.code") }}
									</td>
									<td>
									LARI2020
								</td></tr>
								<tr><td class="heady">
									{{ $t("friendship.data.bib") }}
									</td>
									<td>
									1234
								</td></tr>
								</tbody>
							</table>	
							<b-button href="https://borobudurmarathon.com/friendship-run" block variant="primary">{{ $t("friendship.data.btn") }}</b-button>	
						</div>
					</b-card>

					<b-card
						:title="$t('shuttle.card.head')"
						img-src="/public/images/bus.jpg"
						img-alt="Shuttle Bus"
						img-top
						class="dashCard"
					>
						<div class="busCard">
							<b-card-text>
								{{ $t("shuttle.card.desc") }}
							</b-card-text>

							<b-button v-b-modal.busModal block variant="primary" disabled="disabled">{{ $t("shuttle.card.btn") }}</b-button>
							<bus-modal/>
						</div>

						<div class="busStatus" v-if="transactionStatus">
							<div class="statusPay">
								<b-row class="status">
									<b-col>
										<svg-image image="statusPay"/>
										<h6>{{ $t("shuttle.status.pay.label") }}</h6>
										<p v-html="$t('shuttle.status.pay.desc')"></p>
										<!-- <p>Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your shuttle bus ticket.</p> -->
									</b-col>
								</b-row>
								<b-button v-b-modal.paymentModal block variant="primary">{{ $t("shuttle.status.pay.btn") }}</b-button>
								<!-- <payment-modal :transactionData="transactionData"/> -->
							</div>
							<div class="statusUnpaid">
								<b-row class="status">
									<b-col>
										<svg-image image="statusUnpaid"/>
										<h6>{{ $t("shuttle.status.unpaid.label") }}</h6>
										<p>{{ $t("shuttle.status.unpaid.desc") }}</p>
									</b-col>
								</b-row>
								<b-button v-b-modal.busModal block variant="primary">{{ $t("friendship.status.unpaid.btn") }}</b-button>
							</div>
							<div class="statusSuccess">
								<b-row class="status">
									<b-col>
										<svg-image image="iconBusTicket"/>
										<h6>{{ $t("shuttle.status.success.label") }}</h6>
										<p>{{ $t("shuttle.status.success.desc") }}</p>
									</b-col>
								</b-row>
							</div>
						</div>

						<div class="busTicket" v-if="transactionStatus">
							<table>
								<tbody>
								<tr><td class="heady">
									{{ $t("shuttle.data.code") }}
									</td>
									<td>
									BUS2020
								</td></tr>
								<tr><td class="heady">
									{{ $t("shuttle.data.point") }}
									</td>
									<td>
									Televisi Republik Indonesia Yogyakarta
								</td></tr>
								<tr><td class="heady">
									{{ $t("shuttle.data.dep") }}
									</td>
									<td>
									02.00 - 02.30 WIB (GMT+7)
								</td></tr>
								<tr><td class="heady">
									{{ $t("shuttle.data.ret") }}
									</td>
									<td>
									12.00 WIB (GMT+7)
								</td></tr>
								</tbody>
							</table>		
						</div>
					</b-card>
				
					<b-card
						:title="$t('bib.card.head')"
						img-src="/public/images/bib.jpg"
						img-alt="Bib Transfer"
						img-top
						class="dashCard"
					>
						<b-card-text>
							{{ $t("bib.card.desc") }}
						</b-card-text>

						<b-button v-b-modal.bibModal block variant="primary" disabled="disabled">{{ $t("bib.card.btn") }}</b-button>
						<bib-modal/>
					</b-card>
					
				</b-card-group>
			</b-col>
		</b-row>
		<b-row class="dashRow">
			<b-col md="8" v-if="racepackReady">
				<div class="mainCard">
					<b-card
						img-src="/public/images/rpc.jpg"
						img-alt="Race Pack Collection"
						img-top
					>
					<h2>{{ $t("rpc.card.head") }}</h2>
					<p>{{ $t("rpc.card.desc") }}</p>
					
					<div class="rpcInfo">
					<b-row>
						<b-col md="7" class="rpcSchedule" v-html="$t('rpc.schedule')">
						</b-col>
						<b-col md="5" v-html="$t('rpc.venue')">
						</b-col>
					</b-row>
					</div>

					<div class="groupLabel"><label>{{ $t("rpc.instructions.label") }}</label></div>
					<b-row class="rpcInstructions" v-if="ballotData">
						<b-col md="auto" class="rpcQR">
							<svg-image image="QR"/>
							<h6 style="color:#aaa">{{ballotData.mregOrderId}}</h6>
						</b-col>
						<b-col v-html="$t('rpc.instructions.point')">
						</b-col>
					</b-row>

					<b-button v-b-modal.delegationModal variant="primary">{{ $t("rpc.instructions.btn") }}</b-button>
					<delegation-modal/>
					
					<div class="rpcDelegated">
						<div class="groupLabel"><label>{{ $t("rpc.delegation.label") }}</label></div>
						<div class="statusTransferred">
							<b-row class="status">
								<b-col sm="auto">
									<svg-image image="iconDelegated"/>
								</b-col>
								<b-col>
									<h6>{{ $t("rpc.delegation.statuslabel") }}</h6>
									<p>{{ $t("rpc.delegation.statusdesc") }}</p>
								</b-col>
							</b-row>
						</div>
						<table><tbody>
							<tr>
								<td class="heady">{{ $t("rpc.delegation.rname") }}</td>
								<td>Pengambil Respek</td>
							</tr>
							<tr>
								<td class="heady">{{ $t("rpc.delegation.remail") }}</td>
								<td>pengambil@respek.com</td>
							</tr>
							<tr>
								<td class="heady">{{ $t("rpc.delegation.rphone") }}</td>
								<td>08123456789</td>
							</tr>
						</tbody></table>
					</div>
					<b-button variant="primary">{{ $t("rpc.delegation.cancel") }}</b-button>
					</b-card>
				</div>
			</b-col>
			<b-col md="4" v-if="showRaceDayInfo">
				<b-card
						:title="$t('raceday.card.head')"
						img-src="/public/images/rd.jpg"
						img-alt="Race Day"
						img-top
						class="dashCard"
					>
						<b-card-text>
						{{ $t("raceday.card.desc") }}
						</b-card-text>
						<b-button href="https://borobudurmarathon.com/race-day" block variant="primary">{{ $t("raceday.card.btn") }}</b-button>
				</b-card>
			</b-col>
		</b-row>
		<!-- <b-row class="mt-3">
			<b-col md="12">
				<h4>This Is Secured View</h4>
				<p><strong>Session Data : </strong></p>
				<pre>{{profile}}</pre>
			</b-col>		
		</b-row> -->
		</div>
	</b-container>
</template>

<script>
	import SvgImage from '../components/SvgImage.vue'
	// import VueTimepicker from '../../node_modules/vue2-timepicker/src/vue-timepicker.vue'
	import RegistrationModal from '../components/RegistrationModal.vue'
	import JerseyModal from '../components/JerseyModal.vue'
	import PaymentModal from '../components/PaymentModal.vue'
	import BusModal from '../components/BusModal.vue'
	import BibModal from '../components/BibModal.vue'
   	import DelegationModal from '../components/DelegationModal.vue'
	export default {
		data() {
			return {
				racepackReady : undefined,
				showRaceDayInfo : undefined,
				transactionStatus : undefined,
				channel : null,
				userProfile : {},
				regChannels : {
					en : [
						{ text: '••• Select •••', value: null },
						{ text: 'Ballot Registration', value: 'BALLOT' },
						{ text: 'Fast Runner Qualifying', value: 'FRQ' },
						{ text: 'Bank Jateng Program (Coming Soon)', value: 'JATENG', disabled:true },
						{ text: 'Travel Agent Partners (Coming Soon)', value: 'TRAVEL', disabled:true },
					],
					id : [
						{ text: '••• Pilih •••', value: null },
						{ text: 'Pendaftaran Ballot', value: 'BALLOT' },
						{ text: 'Fast Runner Qualifying', value: 'FRQ' },
						{ text: 'Bank Jateng Program (Segera Hadir)', value: 'JATENG', disabled:true },
						{ text: 'Travel Agent Partners (Segara Hadir)', value: 'TRAVEL', disabled:true },
					],
				},
				categories : [
					{ text: '••• Select •••', value: null },
					{ text: 'Marathon', value: 1 },
					{ text: 'Half Marathon', value: 2 },
					{ text: '10K', value: 3 },
				],
				form : {
					evpaBIBName : null,
					evpaEvncId: null,
					evpaWave: null
				},
				formStatus : {
					evpaBIBName : {
						state : null
					},
					evpaEvncId : {
						state :  null
					},
					evpaWave : {
						state : null
					}
				},
				signedin : true,
				ballotStatus : {
					readyToRegister : false,
					confirmedViaBankJateng : false
				},
				ballotData : undefined,
				ballotDataDetail : undefined,
				transactionData : undefined,
				transferInfo : undefined,
				FRQEntree : undefined,
				// fact : undefined,
				facts : {
					en : [
						'<p>If you circling across 4 stories of Borobudur Temple, you would have walked a total distance of approximately <strong>1.2 kilometers</strong>.</p>',
						'<p>Borobudur is a Buddhist stupa in the Mahayana tradition and it is <strong>the largest Buddhist monument</strong> in the world.</p>',
						'<p>Borobudur is surrounded by the walls and balustrades which are decorated with fine low reliefs, covering a <strong>total surface area of 2,520 meters²</strong>.</p>',
						'<p>Borobudur is decorated with <strong>2,672 relief panels</strong> and <strong>504 Buddha statues</strong>.</p>',
						'<p>Most temples were built on a flat surface while <strong>Borobudur was built on a bedrock hill</strong> located 265 meters above sea level and 15 meters above the floor of a dried-out paleolake.</p>',
						'<p>Approximately <strong>55,000 cubic meters</strong> of stone used in the construction of Borobudur were taken from neighboring rivers. These stone was cut to size, transported to the site and laid without mortar.</p>',
						'<p>Between 928 and 1006 CE, Borobudur was abandoned because the center of power moved to East Java. Soon after a series of volcanic eruptions took places and left <strong>Borobudur hidden for centuries</strong> under layers of volcanic ash and jungle growth.</p>',
						'<p>In the early 1900s, during the restoration of Borobudur, it was discovered that the 3 Buddhist temples in the region – Borobudur, Mendut and Pawon, are lined in <strong>one straight line position</strong>.</p>',
						'<p>The <strong>basic unit measurement</strong> used in the construction of Borobudur was called tala – the length of a human face from the forehead’s hairline to the tip of the chin or the distance from the tip of the thumb to the tip of the middle finger when both fingers are stretched at their maximum distance.</p>',
						'<p><strong>A hidden structure</strong> under the base was accidentally discovered in 1885. The ‘hidden foot’ contains reliefs, 160 of which are narrative describing the real Kamadhatu.</p>',
						'<p>Borobudur contains approximately <strong>2,672 individual bas-reliefs</strong>, 1,460 of which are narrative and 1,212 are decorative panels which cover the balustrades and facades.</p>',
						'<p><strong>Vesak</strong>, a festival commemorates the birth, enlightenment, and death of Gautama Buddha, is a ceremony that is centered at the 3 Buddhist temples in Borobudur region by walking from Mendut to Pawon and end up in Borobudur.</p>',
						'<p>Borobudur was built as <strong>an aquatic lotus</strong> symbol, seen as floating on the adjoining lake.</p>',
						'<p>Borobudur is composed of stone blocks. Each piece of stone is arranged <strong>without the use of cement or adhesive</strong>. These stones are only stacked and spliced ​​with certain patterns to bind each other.</p>',
						'<p>At first glance, all the Buddha statues in Borobudur appear similar, but there is <strong>a subtle difference</strong> between them in the mudras or the position of the hands. There are five groups of mudra: North, East, South, West and Zenith, which represent the five cardinal compass points according to Mahayana.</p>',
						'<p>Borobudur is equipped with a good drainage system to cater for the area’s high stormwater run-off. To prevent flooding, <strong>100 spouts are installed at each corner</strong>, each with a unique carved gargoyle in the shape of a giant or makara.</p>',
						'<p>The architect of Borobudur had used the <strong>4:6:9 ratio</strong> to lay out the precise dimensions of the fractal and self-similar geometry.</p>',
						'<p><strong>Gunadharma</strong> is claimed as the name of the architect of Borobudur. Many sources say that he came from the province of Lalitpur, Nepal.</p>',
					],
					id : [
						'<p><strong>1,2 kilometer</strong> adalah perkiraan jarak yang Anda tempuh jika mengelilingi seluruh Candi Borobudur dalam 4 tingkatannya.</p>',
						'<p>Borobudur adalah stupa Buddha dalam tradisi Mahayana yang menyandang gelar <strong>monumen Buddha terbesar</strong> di dunia.</p>',
						'<p>Borobudur dikelilingi oleh tembok dan langkan yang diisi oleh relief dekoratif, menyelimuti <strong>total area permukaan sebesar 2.520 meter²</strong>.</p>',
						'<p>Borobudur dihiasi oleh <strong>2.672 panel relief</strong> dan <strong>504 patung Buddha</strong>.</p>',
						'<p>Kebanyakan candi dibangun di atas permukaan datar sementara <strong>Borobudur dibangun di atas sebuah bukit batu</strong> setinggi 265 meter di atas permukaan laut dan 15 meter di atas dasar danau purba yang telah mengering.</p>',
						'<p>Sekitar <strong>55.000 meter kubik</strong> batu yang digunakan untuk membangun Borobudur diambil dari sungai sekitar. Batu-batu tersebut dipotong, dipindahkan ke lokasi dan disusun tanpa menggunakan campuran semen.</p>',
						'<p>Sekitar tahun 928 hingga 1006 setelah masehi, Borobudur ditinggalkan karena pusat kekuasaan saat itu berpindah ke Jawa Timur. Rangkaian letusan gunung berapi membuat <strong>Borobudur tertimbun selama beberapa abad</strong> di bawah lapisan abu vulkanik dan semak liar.</p>',
						'<p>Pada awal tahun 1900an, ketika masa pemulihan Borobudur, ditemukan bahwa 3 candi Buddha di daerah tersebut – Borobudur, Mendut dan Pawon, berada pada <strong>satu garis lurus</strong>.</p>',
						'<p><strong>Satuan ukuran baku</strong> yang digunakan dalam membangun Borobudur disebut tala – yaitu panjang wajah manusia dari garis rambut pada kening hingga ujung dagu atau panjang ujung ibu jari ke jari tengah ketika kedua jari direnggangkan pada jarak maksimum.</p>',
						'<p><strong>Struktur tersembunyi</strong> di bawah dasar ditemukan tidak disengaja pada tahun 1885. ‘Kaki tersembunyi’ ini menyimpan relief, dimana 160 di antaranya menceritakan Kamadhatu.</p>',
						'<p>Borobudur disusun atas <strong>2.672 relief</strong>, 1.460 di antaranya bersifat naratif sementara 1.212 lainnya bersifat dekoratif yang menghiasi fasad dan langkan.</p>',
						'<p><strong>Waisak</strong>, sebuah perayaan memperingati kelahiran, pencerahan, dan kematian Siddhartha Gautama, adalah perayaan yang dipusatkan pada 3 candi Buddha di area Borobudur. Dimulai dari berjalan dari Mendut ke Pawon dan berakhir di Borobudur.</p>',
						'<p>Borobudur dibangun sebagai simbol <strong>teratai air</strong>, terlihat mengapung di atas sebuah danau.</p>',
						'<p>Borobudur tersusun atas blok-blok batu. Setiap batu disusun <strong>tanpa menggunakan semen atau perekat</strong>. Batu-batu tersebut hanya disusun dan dipotong dengan pola tertentu untuk mengunci satu sama lain.</p>',
						'<p>Sekilas, seluruh patung Buddha di Borobudur tampak sama, tetapi terdapat <strong>perbedaan halus</strong> di antara mereka dalam kategori mudra atau sikap tangan simbolis. Terdapat lima kategori mudra: Utara, Timur, Selatan, Barat, dan Tengah, kesemuanya berdasarkan lima arah utama kompas menurut ajaran Mahayana.</p>',
						'<p>Borobudur dilengkapi sistem drainase air untuk mencegah banjir dengan <strong>100 pancuran yang terdapat di setiap sudut</strong>, masing-masing dihiasi pahatan raksasa atau makara.</p>',
						'<p>Arsitek Borobudur diyakini menggunakan <strong>rasio 4:6:9</strong> dalam menata ukuran geometri dalam konstruksi Borobudur secara presisi.</p>',
						'<p><strong>Gunadharma</strong> diklaim sebagai nama arsitek perancang Borobudur. Banyak sumber mengatakan bahwa ia berasal dari Lalitpur, Nepal.</p>',
					]
				}
				// profile: null
			}
		},
		computed : {
			regChannel : function(){
				return this.regChannels[this.$i18n.locale]
			},
			fact : function(){
				return this.facts[this.$i18n.locale][Math.floor(Math.random() * this.facts[this.$i18n.locale].length)];
			},
			isLoggedIn : function(){ 
				return this.$store.getters.isLoggedIn
			}
		},
		// watch: {
		// 	'$i18n.locale': function(newVal, oldVal) {
		// 		console.log('locale change', newVal)
		// 	}
		// },
		components : {
			// VueTimepicker,
			SvgImage,
			RegistrationModal,
			JerseyModal,
			PaymentModal,
			BusModal,
			BibModal,
			DelegationModal,
		},
		methods: {
			photoProfileError(event){
				event.target.src = "/public/images/anonymous.jpg"
				// console.log(this, event)
			},
			onSubmit(){

			},
			parseBallotStatus(){
				console.log('Define rule for ballot status : ', this.userProfile);
				console.log('Ballot Data : ', this.ballotData);
				this.ballotStatus.readyToRegister = true;
				if (this.ballotData){
					this.ballotStatus.readyToRegister = false;
					if (this.ballotData.mregStatus==1){
						this.ballotStatus.approved = true;
					} else {
						this.ballotStatus.waiting = true;
					}
				}
				if (this.userProfile.fastRunnerInfo){
					this.ballotStatus.frqWaiting = true;
					this.ballotStatus.waiting = false;
				}
			},
			init(){
				this.$store.dispatch('GETPROFILE')
					.then((profileOut)=>{
						// this.profile = profileOut.data;
						this.$store.commit('SET_USER', {id: profileOut.data.data[0].id, user: profileOut.data});
						this.userProfile = this.$store.getters.getUserProfile;
						if (this.userProfile.memberLanguage){
							// console.log('language : ', this.userProfile.memberLanguage)
							if (this.userProfile.memberLanguage == 2){
								this.$i18n.locale = 'id';
							} else {
								this.$i18n.locale = 'en';
							}
						}
						if (this.userProfile.readyToRegister){
							if (this.userProfile.registeredEvents){
								if (this.userProfile.registeredEvents[208]){
									// this.ballotStatus.readyToRegister = true;
									//this.ballotStatus.waiting = true;
									// this.ballotStatus.approved = true;
									this.ballotData = this.userProfile.registeredEvents[208];
									this.$store.dispatch('GETTRANSACTION', {data:this.ballotData.mregOrderId})
										.then((transactionOut)=>{
											this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
											this.transactionData = transactionOut.data;
											this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
											console.log('Transaction out : ', transactionOut, this.ballotDataDetail);
											// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
										})
										.catch((err)=>{
											console.log(err);
										})
								}
								// console.log(this.userProfile.registeredEvents[208]);
							}
							if (!this.userProfile.profileComplete||!this.userProfile.phoneVerified){
								this.$router.push('/profile');
							} else {
								this.parseBallotStatus();
								// this.ballotStatus.readyToRegister = false;
							}
						} else {
							if (this.userProfile.profileComplete){
								// This is patch to force unverified member to register
								this.ballotStatus.readyToRegister = true;
								if (this.userProfile.registeredEvents&&this.userProfile.registeredEvents[208]){
									this.ballotStatus.readyToRegister = false;
									if (this.userProfile.registeredEvents[208]){
										// this.ballotStatus.readyToRegister = true;
										//this.ballotStatus.waiting = true;
										// this.ballotStatus.approved = true;
										this.ballotData = this.userProfile.registeredEvents[208];
										this.$store.dispatch('GETTRANSACTION', {data:this.ballotData.mregOrderId})
											.then((transactionOut)=>{
												this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
												this.transactionData = transactionOut.data;
												this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
												console.log('Transaction out : ', transactionOut, this.ballotDataDetail);
												// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
											})
											.catch((err)=>{
												console.log(err);
											})
									}
									// console.log(this.userProfile.registeredEvents[208]);
								}
								// <<< This is patch to force unverified member to register
								// this.parseBallotStatus();
							} else {
								this.$router.push('/profile');
							}
							// console.log('aaaaa', this.userProfile);
						}
						console.log('User profile data : ', this.userProfile);
					})
					.catch((err)=>{
						this.$router.push('/signin');
						console.log('profile error : ', err)
					})				
			}
		},
		mounted(){
			this.init();
			// this.fact = this.facts[Math.floor(Math.random() * this.facts.length)];
			// this.modalShow = true;
			// this.$bvModal.show('registrationModal');
			// console.log(this.$bvModal);
			// this.$refs['registrationModal'].show();
			// this.$store.dispatch('REGISTEREVENT',{data:{id:1}})

			// this.$store.dispatch('CHECK')
			// 	.then((checkOut) =>{
			// 		console.log(checkOut);
			// 		this.data = checkOut.data;
			// 	})
			// 	.catch(err => {
			// 		console.log(err);
			// 	})
		},
	}
</script>


// WEBPACK FOOTER //
// HomeView.vue